"use client";

import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import "./DoctorTabs.css";

export default function DoctorTabs({ active, onChange }) {
  const { t } = useTranslation();

  const TABS = useMemo(
    () => [
      { key: "info", label: t("doctorTabs.info") },
      { key: "posts", label: t("doctorTabs.posts") },
    ],
    [t]
  );

  return (
    <div className="dpt-wrap">
      {TABS.map((t) => (
        <button
          key={t.key}
          className={`dpt-tab ${active === t.key ? "isActive" : ""}`}
          onClick={() => onChange?.(t.key)}
          type="button"
        >
          {t.label}
        </button>
      ))}
    </div>
  );
}
